import { createSlice } from "@reduxjs/toolkit";
import {
  createOrderBuilder,
  deleteOrderBuilder,
  getOrdersBuilder,
  updateOrderStatusBuilder,
} from "./builder";

const initialState = {
  order: {
    newOrder: null,
    loading: false,
    error: null,
  },
  orders: {
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
      totalOrders: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      limit: 12,
    },
    sortByStatus: false,
    lastMonthRevenue: 0,
    thisMonthRevenue: 0,
    totalRevenue: 0,
    loading: false,
    deleteLoading: false,
    updateStatusLoading: false,
    error: null,
  },
};

export const ordersSlice = createSlice({
  name: "ordersInfo",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.orders.pagination.currentPage = action.payload;
    },
    setSortByStatus: (state, action) => {
      state.orders.sortByStatus = action.payload;
    },
    resetOrders: (state) => {
      state.orders.data = [];
      state.orders.pagination = initialState.orders.pagination;
    },
  },
  extraReducers: (builder) => {
    getOrdersBuilder(builder);
    createOrderBuilder(builder);
    deleteOrderBuilder(builder);
    updateOrderStatusBuilder(builder);
    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

export const { setCurrentPage, resetOrders, setSortByStatus } =
  ordersSlice.actions;

export const selectOrder = (state) => state.ordersInfo.order;
export const selectOrders = (state) => state.ordersInfo.orders;

export default ordersSlice.reducer;
